module.exports = __webpack_public_path__ + "img/hglhj.68af4ba4.jpg";